<ng-template #sortIcon let-column>
    <span
        hamIconShapes
        [icon]="
            activeSortBy !== column
                ? 'assets/hamIcons/chevron-sort.svg'
                : activeSortOrder === 'asc'
                ? 'assets/hamIcons/chevron-sort-ascending.svg'
                : 'assets/hamIcons/chevron-sort-descending.svg'
        "
        [size]="'s'"
        [keepOriginalColors]="'true'"
        [variant]="'none'"
    ></span>
</ng-template>

<ng-template #emptyState>
    <div class="empty-state-wrapper">
        <div class="empty-state">
            <span
                class="building-wrapper"
                hamIconShapes
                [icon]="anyActiveFilter ? 'assets/hamIcons/exclamation-outline.svg' : 'assets/hamIcons/user.svg'"
                [size]="'50px'"
            ></span>
            <div class="text1">
                {{ (anyActiveFilter ? 'cpmm_projects_overview_empty_filtered_text1' : 'aumico_person_projects_empty') | i18next }}
            </div>
            <div class="text2">
                {{
                    (anyActiveFilter
                        ? 'cpmm_projects_overview_empty_filtered_text2'
                        : 'aumico_person_projects_empty_instructions'
                    ) | i18next
                }}
            </div>
            <ham-button
                *ngIf="!anyActiveFilter"
                type="submit"
                icon="assets/hamIcons/plus-outline.svg"
                [disabled]="disableNewProjectButton"
                data-testid="person-projects-empty-new-project"
                (buttonClick)="addNewProject.emit()"
            >
                {{ 'aumico_projects_overview_add_new_project' | i18next }}
            </ham-button>
        </div>
    </div>
</ng-template>

<ng-container *ngIf="projects && projects.length > 0; else emptyState">
    <div class="table-wrapper" [ngStyle]="{ '--table-width': totalTableLength + 'px' }" [class.noCPMM]="summaries.length === 0">
        <ham-table-with-actions
            [dataSource]="projects"
            [pagination]="false"
            [columnClasses]="columnClasses"
            [tableStyles]="'overflow-x: auto;'"
            hideActions="true"
            showActionsInRowsOnly="true"
            data-testid="person-projects-table"
            rowTestId="person-project-row"
        >
            <!-- Group header: blank over the fixed columns, "Mandatsverwaltung" over the sections -->
            <tr groupHeaderRow class="group-header-row">
                <th class="stick-0"></th>
                <th *ngIf="!hidePersonColumn" class="middle-cols-MM col1" [class.noCPMM]="summaries.length === 0"></th>
                <th *ngIf="showAssigneeColumn" class="middle-cols-MM col2" [class.noCPMM]="summaries.length === 0"></th>
                <th class="middle-cols-MM col3" [class.noCPMM]="summaries.length === 0"></th>
                <th *ngIf="showTags" class="middle-cols-MM col4" [class.noCPMM]="summaries.length === 0"></th>
                <th
                    *ngIf="summaries.length > 0"
                    [attr.colspan]="summaries.length"
                    class="group-header first-group bg-indigo-100"
                >
                    {{ 'cpmm_projects_overview_group_mandate_management' | i18next }}
                </th>
                <th class="group-header-row sticky-action bg-indigo-50" [class.noCPMM]="summaries.length === 0"></th>
            </tr>

            <!-- Column headers -->
            <ng-template hamHeaderCell>
                <div
                    class="header-text-container company"
                    (click)="sortBy(hidePersonColumn ? 'periodEnd' : 'personName')"
                >
                    <div
                        class="checkbox-wrapper"
                        style="padding: 10px; cursor: pointer; display: inline-flex; align-items: center"
                        (click)="$event.stopPropagation(); onToggleCheckAllProject()"
                    >
                        <span hamCheckbox [checked]="allProjectsSelected" (change)="onToggleCheckAllProject()"></span>
                    </div>
                    {{ (hidePersonColumn ? 'aumico_person_projects_col_period' : 'aumico_person_projects_col_person') | i18next }}
                    <ng-container
                        *ngTemplateOutlet="sortIcon; context: { $implicit: hidePersonColumn ? 'periodEnd' : 'personName' }"
                    ></ng-container>
                </div>
            </ng-template>
            <ng-template hamHeaderCell *ngIf="!hidePersonColumn">
                <div class="header-text-container bs-date" (click)="sortBy('periodEnd')">
                    {{ 'aumico_person_projects_col_period' | i18next }}
                    <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'periodEnd' }"></ng-container>
                </div>
            </ng-template>
            <ng-template hamHeaderCell *ngIf="showAssigneeColumn">
                <div class="header-text-container person">
                    {{ 'cpmm_projects_overview_col_responsible' | i18next }}
                </div>
            </ng-template>
            <ng-template hamHeaderCell>
                <div class="header-text-container status" (click)="sortBy('projectStatus')">
                    {{ 'cpmm_projects_overview_col_status' | i18next }}
                    <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: 'projectStatus' }"></ng-container>
                </div>
            </ng-template>
            <ng-template hamHeaderCell *ngIf="showTags">
                <div class="header-text-container">{{ 'aumico_person_projects_col_tag' | i18next }}</div>
            </ng-template>
            <ng-container *ngFor="let summary of summaries">
                <ng-template hamHeaderCell>
                    <span hamTooltip="{{ summary }}">{{ summary }}</span>
                </ng-template>
            </ng-container>

            <!-- Rows -->
            <ng-template hamCell let-element (cellClick)="onSelect($event)">
                <div style="display: flex; align-items: center; gap: 8px" [class.selected]="selectedProjects.has(element.projectId)">
                    <div
                        class="checkbox-wrapper"
                        style="padding: 10px; cursor: pointer; display: flex; align-items: center"
                        (click)="onProjectCheckboxClick(element.projectId, $event)"
                    >
                        <span class="checkBox" hamCheckbox [checked]="selectedProjects.has(element.projectId)" [bubbleEvents]="true"></span>
                    </div>
                    <div class="company-name">
                        <span class="company-name-text" data-testid="person-projects-person-name">
                            <ng-container *ngIf="!hidePersonColumn; else periodInFirstColumn">{{ element.personName }}</ng-container>
                            <ng-template #periodInFirstColumn>
                                {{ 'aumico_person_projects_tax_period' | i18next: { year: element.taxYear } }}
                            </ng-template>
                        </span>
                    </div>
                </div>
            </ng-template>
            <ng-template hamCell let-element (cellClick)="onSelect($event)" *ngIf="!hidePersonColumn">
                <span data-testid="person-projects-period">
                    {{ 'aumico_person_projects_tax_period' | i18next: { year: element.taxYear } }}
                </span>
            </ng-template>
            <ng-template hamCell let-element (cellClick)="onSelect($event)" *ngIf="showAssigneeColumn">
                <div style="position: relative; display: inline-flex; align-items: center">
                    <ham-avatar
                        style="display: inline-block; width: 35px; height: 35px; position: relative; z-index: 2"
                        type="circle"
                        variant="grey-border"
                        size="regular"
                        [class.deleted]="element.assigneeDeleted"
                        [fullName]="element.assignee ?? '-'"
                        hamTooltip="{{ element.assignee }}"
                    ></ham-avatar>
                    <ham-avatar
                        style="display: inline-block; width: 35px; height: 35px; position: relative; z-index: 1; margin-left: -12px"
                        type="circle"
                        variant="grey-border"
                        size="regular"
                        [class.deleted]="element.clerkDeleted"
                        [fullName]="element.clerk ?? '-'"
                        hamTooltip="{{ element.clerk }}"
                    ></ham-avatar>
                </div>
            </ng-template>
            <ng-template hamCell let-element (cellClick)="onSelect($event)">
                <span
                    class="badge"
                    [class.--green]="element.projectStatus === 'done'"
                    [class.--blue]="element.projectStatus === 'active'"
                    data-testid="person-projects-status"
                >
                    {{ 'cpmm_projects_overview_badge_' + element.projectStatus | i18next }}
                </span>
            </ng-template>
            <ng-template hamCell let-element (cellClick)="onSelect($event)" *ngIf="showTags">
                <div class="person-project-tags">
                    <ham-tag-pill *ngFor="let tag of element.tags ?? []" [label]="tag"></ham-tag-pill>
                </div>
            </ng-template>
            <ng-container *ngFor="let summary of summaries">
                <ng-template hamCell let-element (cellClick)="onSelect($event, summary)">
                    <div
                        class="badge-wrapper"
                        (mouseenter)="startHover($event, element.projectId, summary)"
                        (mouseleave)="endHover()"
                    >
                        <span
                            class="badge"
                            [class.--red]="taskStatus(element, summary) === 'overdue'"
                            [class.--yellow]="taskStatus(element, summary) === 'almostOverdue'"
                            [class.--green]="taskStatus(element, summary) === 'done'"
                            data-testid="person-projects-progress"
                        >
                            {{ getSummaryBadge(element, summary) }}
                        </span>
                        <span
                            *ngIf="hoveredProjectId === element.projectId && hoveredSummary === summary && hoveredIssues().length !== 0"
                            class="issue-details-flyout"
                            hamFlyout
                            [position]="issueDetailsFlyoutPosition"
                            [disableBackdrop]="true"
                            (mouseenter)="keepFlyoutOpen()"
                            (mouseleave)="endHover()"
                        >
                            <div class="issue-details-flyout-content">
                                <ul>
                                    <li
                                        *ngFor="let item of hoveredIssues()"
                                        class="issue-item"
                                        [class.--red]="isOverdue(item.dueDate) && item.state !== TaskState.DONE"
                                        [class.--yellow]="isDueSoon(item.dueDate) && item.state !== TaskState.DONE"
                                        style="display: flex; justify-content: space-between"
                                    >
                                        <span (click)="onSelect(element, summary)">{{ item.name }}</span>
                                        <span
                                            *ngIf="item.state === TaskState.DONE"
                                            hamIconShapes
                                            icon="assets/hamIcons/check-circle.svg"
                                            [size]="'exact20'"
                                            [variant]="'all-green'"
                                            (click)="onChangeTaskState(element.projectId, item.issueId, TaskState.OPEN)"
                                        ></span>
                                        <span
                                            *ngIf="item.state !== TaskState.DONE"
                                            class="taks-icons"
                                            hamIconShapes
                                            icon="assets/hamIcons/empty-circle-outline.svg"
                                            [size]="'exact20'"
                                            [variant]="'transparent'"
                                            (click)="onChangeTaskState(element.projectId, item.issueId, TaskState.DONE)"
                                        ></span>
                                    </li>
                                </ul>
                            </div>
                        </span>
                    </div>
                </ng-template>
            </ng-container>

            <!-- "…" menu: status, delete -->
            <ng-template hamMenuButton let-element>
                <div class="action-button-wrapper">
                    <ham-button
                        stopPropagation
                        #actionButton
                        class="action-button"
                        size="xs"
                        variant="transparent"
                        icon="assets/hamIcons/dots-horizontal.svg"
                        data-testid="person-projects-row-actions"
                        (click)="openActionFlyout(element.projectId, actionButton)"
                    ></ham-button>
                </div>
                <span
                    class="action-menu-flyout"
                    hamFlyout
                    *ngIf="openedActionFlyoutProjectId === element.projectId"
                    [position]="actionFlyoutPosition"
                    (closeFlyout)="closeActionFlyout()"
                >
                    <div class="flyout-content">
                        <div *ngIf="element.projectStatus !== ProjectStatus.DONE" class="action" (click)="onMarkDone(element)">
                            <span hamIconShapes icon="assets/hamIcons/check-circle-outline.svg" [variant]="'transparent'" [size]="'xs'"></span>
                            {{ 'cpmm_projects_overview_action_change_status_to_done' | i18next }}
                        </div>
                        <div
                            *ngIf="element.projectStatus !== ProjectStatus.ACTIVE"
                            class="action"
                            (click)="onUpdateStatus(element.projectId, ProjectStatus.ACTIVE, false)"
                        >
                            <span hamIconShapes icon="assets/hamIcons/minus-outline.svg" [variant]="'transparent'" [size]="'xs'"></span>
                            {{ 'cpmm_projects_overview_action_change_status_to_active' | i18next }}
                        </div>
                        <div class="action red" (click)="openProjectDeletionConfirmationDialog = true">
                            <span hamIconShapes icon="assets/hamIcons/trash-outline.svg" [variant]="'transparent'" [size]="'xs'"></span>
                            {{ 'cpmm_projects_overview_action_delete_project' | i18next }}
                        </div>
                        <ham-confirm-decline-modal
                            *ngIf="openProjectDeletionConfirmationDialog"
                            (cancel)="openProjectDeletionConfirmationDialog = false"
                            (action)="onDeleteProject(element.projectId)"
                            footerAlignment="center"
                            actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
                            noActionBtnText="{{ 'aumico_reports_cancel_delete' | i18next }}"
                        >
                            <ham-general-confirm-decline-modal-body
                                [text]="'aumico_project_overview_project_deletion_confirmation_text' | i18next"
                            ></ham-general-confirm-decline-modal-body>
                        </ham-confirm-decline-modal>
                    </div>
                </span>
            </ng-template>
        </ham-table-with-actions>
    </div>
</ng-container>

<ham-confirm-decline-modal
    *ngIf="openAutoTaskUpdateDialog"
    (cancel)="onUpdateStatus(projectIdToBeChanged, ProjectStatus.DONE, false)"
    (action)="onUpdateStatus(projectIdToBeChanged, ProjectStatus.DONE, true)"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_projects_overview_status_update_modal_confirm' | i18next }}"
    noActionBtnText="{{ 'aumico_projects_overview_status_update_modal_cancel' | i18next }}"
    btnVariant="primary"
>
    <div class="ham-icon"><i class="check-circle-outline"></i></div>
    <p class="project-update-modal-text">{{ 'aumico_projects_overview_status_update_modal_text' | i18next }}</p>
</ham-confirm-decline-modal>
